import React, { FC } from 'react';
import { ServiceCard, ServiceCardButton, ServiceCardContent } from '../service-card';
import { cx } from 'linaria';
import { icon, verticalIcon } from './styles';
import { RelatedServiceProps } from '../types';

export const DATA_QA_RELATED_SERVICE_ICON = 'related-services-icon_mf-pdp';

export const RelatedService: FC<RelatedServiceProps> = ({
  service: { iconLeftSrc, title, price },
  href,
  onClick,
  vertical,
  className,
}) => {
  return (
    <ServiceCard onClick={onClick} href={href} vertical={vertical} className={className}>
      <ServiceCardContent title={title}>
        {iconLeftSrc ? (
          <img
            className={cx(icon, vertical ? verticalIcon : null)}
            src={iconLeftSrc}
            alt={title}
            data-qa={DATA_QA_RELATED_SERVICE_ICON}
          />
        ) : null}
      </ServiceCardContent>
      <ServiceCardButton price={price?.value} />
    </ServiceCard>
  );
};
